import MindMap from "@/components/MindMap";
import { SUBJECT_META, Tags, Section, buildKeywordRegex, highlight } from "./shared";
import { KeyPointsSection } from "./KeyPoints";
import { DefinitionsSection } from "./Definitions";
import { FormulaSheetSection } from "./Formulas";
import { DiagramsSection } from "./Diagrams";
import { FlowchartsSection } from "./Flowcharts";
import { TablesSection } from "./Tables";
import { TimelineSection } from "./Timeline";
import { WorkedExamplesSection } from "./WorkedExamples";
import { MainIdeasSection, QuotesSection } from "./MainIdeas";
import { ImportantFactsSection, FrequentlyEmphasizedSection, LowConfidenceSection } from "./Facts";
import { OneMinuteRevisionSection, ExamQuestionsSection } from "./QuickRecall";
import { StickyNotesSection } from "./StickyNotes";

export default function LectureNotes({ n }) {
  const regex = buildKeywordRegex(n.keywords);
  const subjectKey = SUBJECT_META[n.subject] ? n.subject : "general";
  const subject = SUBJECT_META[subjectKey];
  const SubjectIcon = subject.icon;
  const defsLabel = subjectKey === "biology" || subjectKey === "chemistry" ? "Vocabulary" : "Definitions";

  return (
    <>
      <div className="flex flex-wrap items-center gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">/ Topic</p>
        <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest bg-black text-[#3B82F6] px-2 py-0.5">
          <SubjectIcon className="w-3 h-3" /> {subject.label}
        </span>
      </div>
      <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tighter mt-1">
        {n.topic || "Untitled"}
      </h1>

      {n.one_line_summary && (
        <p className="lead-summary mt-4 text-base sm:text-lg leading-relaxed text-zinc-800 border-l-2 border-[#3B82F6] pl-4">
          <span className="float-left font-heading font-black text-4xl leading-none mr-2 mt-1 text-[#3B82F6]">
            {(n.one_line_summary[0] || "•").toUpperCase()}
          </span>
          {highlight(n.one_line_summary.slice(1), regex)}
        </p>
      )}

      <Tags tags={n.tags} />

      <KeyPointsSection concepts={n.core_concepts} regex={regex} />
      <StickyNotesSection items={n.sticky_notes} regex={regex} />
      <DefinitionsSection definitions={n.definitions} regex={regex} label={defsLabel} />
      <WorkedExamplesSection examples={n.worked_examples} regex={regex} />

      {n.diagrams?.length > 0 && <DiagramsSection diagrams={n.diagrams} />}

      <TimelineSection timeline={n.timeline} regex={regex} />
      <MainIdeasSection mainIdeas={n.main_ideas} regex={regex} />
      <QuotesSection quotes={n.quotes} regex={regex} />
      <FlowchartsSection flowcharts={n.flowcharts} regex={regex} />
      <TablesSection tables={n.tables} regex={regex} />
      <FormulaSheetSection formulas={n.formulas} regex={regex} />
      <ImportantFactsSection facts={n.important_facts} regex={regex} />
      <FrequentlyEmphasizedSection items={n.frequently_emphasized} regex={regex} />
      <OneMinuteRevisionSection items={n.one_minute_revision} regex={regex} />
      <ExamQuestionsSection questions={n.exam_questions} regex={regex} />

      {n.mind_map?.center && n.mind_map?.branches?.length > 0 && (
        <Section label="Mind Map">
          <MindMap mindMap={n.mind_map} />
        </Section>
      )}

      <LowConfidenceSection items={n.low_confidence_notes} regex={regex} />
    </>
  );
}
